export const Seal = ({ className = "" }) => (
  <div className={`pointer-events-none select-none ${className}`} aria-hidden="true" data-testid="one-of-one-seal">
    <svg viewBox="0 0 100 100" className="h-16 w-16 sm:h-20 sm:w-20">
      <circle cx="50" cy="50" r="48" fill="#F4EEE3" stroke="#9A7B3F" strokeWidth="1" />
      <circle cx="50" cy="50" r="33" fill="none" stroke="#9A7B3F" strokeWidth="0.5" />
      <defs>
        <path id="sealArc" d="M50,50 m-40.5,0 a40.5,40.5 0 1,1 81,0 a40.5,40.5 0 1,1 -81,0" />
      </defs>
      <text fontFamily="'JetBrains Mono', monospace" fontSize="7.6" letterSpacing="2.2" fill="#55504A">
        <textPath href="#sealArc">SANZONE · AUTHENTICATED · ONE OF ONE ·</textPath>
      </text>
      <text x="50" y="56" textAnchor="middle" fontFamily="'Bodoni Moda', serif" fontSize="19" fill="#5E1A22">
        01/01
      </text>
    </svg>
  </div>
);
